import { CLIENT_DOMAIN } from '../constant/actionTypes';

const getClientDomains = (state, action) => {
  switch (action.type) {
    case CLIENT_DOMAIN.DATA.INITIATE:
      return { isFetching: true };
    case CLIENT_DOMAIN.DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case CLIENT_DOMAIN.DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getClientDomains;
